import type { ArticlePageComponent } from 'queries/graphql';

import FeaturedIn from 'generic/FeaturedIn';
import CtaButton from 'generic/CtaButton';

import ContentModule from './ContentModule';
import ProductCard from './ProductCard';
import TwoColumnCta from './TwoColumnCta';
import ReasonsWhy from './ReasonsWhy';
import Reviews from './Reviews';
import Timeline from './Timeline';

export function Components({ components }: { components: ArticlePageComponent[] }) {
  return components.map((component, index) => {
    const {
      featuredIn,
      ctaButton,
      contentModule,
      productCards,
      twoColumnCta,
      reasonsWhy,
      reviews,
      timeline,
    } = component;

    if (featuredIn) {
      return <FeaturedIn key={index} {...featuredIn} />;
    } else if (ctaButton) {
      return <CtaButton key={index} {...ctaButton} />;
    } else if (contentModule) {
      return <ContentModule key={index} {...contentModule} />;
    } else if (productCards) {
      return <ProductCard key={index} {...productCards} />;
    } else if (twoColumnCta) {
      return <TwoColumnCta key={index} {...twoColumnCta} />;
    } else if (reasonsWhy) {
      return <ReasonsWhy key={index} {...reasonsWhy} />;
    } else if (reviews) {
      return <Reviews key={index} {...reviews} />;
    } else if (timeline) {
      return <Timeline key={index} {...timeline} />;
    }

    return null;
  });
}
